import { Tab, Theme } from '@material-ui/core';
import { withStyles } from '@material-ui/styles';

export default withStyles((theme: Theme) => ({
  root: {
    backgroundColor: '#eeeeee',
    borderBottom: 'none !important',
    borderRadius: '42px',
    fontWeight: 700,
    marginRight: '15px'
  },
  selected: {
    borderBottom: 'none !important',
    backgroundColor: theme.palette.secondary.main,
    color: 'white'
  }
}))(Tab);
